import { ListResponse } from '.';
import { PublicServiceMeta } from '../models/public-service';
import { PublicServiceModel } from '../models/public-service/public-service.model';
import { get } from './sp-api.service';

const SAFE_LIMIT = 1000;

export const getPublicServiceAppData = async (): Promise<PublicServiceMeta[]> => {
  const fields = ['name', 'image', 'description', 'risk', 'support', 'website'];

  const { data } = (await get('/models/public-services', {
    page: 1,
    pageSize: SAFE_LIMIT,
    fields: fields,
  })) as ListResponse;

  return (data || []).map((row) => new PublicServiceModel(row).meta);
};
